<app-alerts />

<app-warehouse-receipt-form
  (submitSuccessEvent)="handleSubmitSuccessEvent($event)"
  [fileUploadVisibility]="fileUploadVisibility()" />
